import axiosInstance from "@/api/axios-instance";

export async function getInternalUsers({
  page,
  search,
}: {
  page: number;
  search?: string;
  clerk_id?: string;
}) {
  const response = await axiosInstance.get("/internal/user", {
    params: {
      page,
      search,
    },
  });

  if (!response.status.toString().startsWith("2")) {
    throw new Error("Internal Users Not Loaded");
  }
  const {
    internalUsers,
    nextPage,
    lastPage,
    page: currentPage,
  } = response.data;

  return {
    internalUsers,
    nextPage,
    lastPage,
    currentPage,
  };
}

export async function getInternalUserByEmail({ email }: { email: string }) {
  const response = await axiosInstance.get("/internal/user/email", {
    params: {
      email,
    },
  });

  if (!response.status.toString().startsWith("2")) {
    throw new Error("Internal User Not Loaded");
  }

  return response.data;
}

export async function updateInternalUserRole({
  clerk_id,
  role,
}: {
  clerk_id: string;
  role: string;
}) {
  const response = await axiosInstance.post("/internal/user/role", {
    clerk_id,
    role,
  });

  if (!response.status.toString().startsWith("2")) {
    throw new Error("Internal User Role Update Failed");
  }

  return response.data;
}

export async function deleteInternalUser(clerk_id: string) {
  const response = await axiosInstance.post("/internal/user/delete", {
    clerk_id,
  });

  if (!response.status.toString().startsWith("2")) {
    throw new Error("Internal User Ban Failed");
  }

  return response.data;
}

export async function updateExotelPhone(phone: string | null) {
  const response = await axiosInstance.patch("/internal/user/exotel-phone", {
    exotel_phone_number: phone,
  });

  if (!response.status.toString().startsWith("2")) {
    throw new Error("ExoTel phone update failed");
  }

  return response.data;
}

export async function updateOtherExotelPhone({
  target_clerk_id,
  phone,
}: {
  target_clerk_id: string;
  phone: string | null;
}) {
  const response = await axiosInstance.patch(
    "/internal/user/exotel-phone/admin",
    { target_clerk_id, exotel_phone_number: phone },
  );

  if (!response.status.toString().startsWith("2")) {
    throw new Error("ExoTel phone update failed");
  }

  return response.data;
}
